export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10699.ad2d29b1.jpg";